export default "__VITE_ASSET__37aa2c3e__"